import { Component } from '@angular/core';

@Component({
  selector: 'app-consent-withdrawn',
  imports: [],
  templateUrl: './consent-withdrawn.component.html',
  styleUrl: './consent-withdrawn.component.css'
})
export class ConsentWithdrawnComponent {

}
